// client/admin-client/src/pages/MarqueeManagement.jsx
import React from 'react';
import MarqueeManager from '../components/MarqueeManager';

export default function MarqueeManagement() {
  return <MarqueeManager />;
}
